import { generatePath } from 'react-router-dom';
import { AppRoute, AppRouteConfig } from '../../core/AppRoute';

export class AdminAppRoute extends AppRoute {
    constructor(path: string, t_key: string, config?: AppRouteConfig) {
        super(path, t_key, config);
    }

    sub(subPath: string, t_key: string, config?: AppRouteConfig) {
        const route = new AdminAppRoute(`${this.path}/${subPath}`, t_key, {
            accessPrivilege: this.config.accessPrivilege,
            ...config,
        });
        return route;
    }

    get t_name(): string {
        return this.tt('name');
    }
    get t_short(): string {
        return this.tt('short');
    }

    get t_long(): string {
        return this.tt('long');
    }

    tt(key: string): string {
        return `adminroutes:${this.t_key}.${key}`;
    }

    tt2(): string {
        return `adminroutes:${this.t_key}`;
    }

    interpolatedPath(params?: Record<string, string>): string {
        return generatePath(this.path, params);
    }

    interpolatedClone(params?: Record<string, string>, query?: Record<string, string>): AdminAppRoute {
        const clone = new AdminAppRoute(this.interpolatedPath(params), this.t_key, { ...this.config });
        const queryStr = new URLSearchParams(query).toString();

        if (queryStr !== '') clone.path += `?${queryStr}`;

        return clone;
    }

    clone(config: AppRouteConfig = {}) {
        const clone = new AdminAppRoute(this.path, this.t_key, { ...this.config, ...config });
        return clone;
    }
}
